import React from 'react';
import type { Permission } from '../data/models/permission.model';
import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';
import { useHasPermission } from './permissions/useHasPermission';

export const useIsInternalUser = (): boolean => {
  const [isInternalUser, setIsInternalUser] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const createBasicAllPermission: Permission = {
    resource: 'providers',
    action: 'createbasic',
    scope: 'all',
  };
  const updateBasicAllPermission: Permission = {
    resource: 'providers',
    action: 'updatebasic',
    scope: 'all',
  };

  const canEditProvider = useHasPermission(user, updateBasicAllPermission);
  const canCreateProvider = useHasPermission(user, createBasicAllPermission);

  React.useEffect(() => {
    setIsInternalUser(canEditProvider || canCreateProvider);
  }, [canEditProvider, canCreateProvider]);

  return isInternalUser;
};

export const useIsALUser = (): boolean => {
  const [isALUser, setIsALUser] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const userAdminPermission: Permission = {
    resource: 'users',
    action: 'updatebasic',
    scope: 'all',
  };

  const hasUserAdminPermission = useHasPermission(user, userAdminPermission);

  React.useEffect(() => {
    setIsALUser(hasUserAdminPermission);
  }, [hasUserAdminPermission]);

  return isALUser;
};
